<template>
  <div class="home">
    <div class="alert">
      <h1>Porfavor gire la pantalla</h1>
    </div>

    <div class="pasta">
      <span v-if="init && end" @click.prevent="next" class="flecha fdere">
        <img class="arrow" src="../assets/isq.png" alt />
      </span>
      <span v-if="init" @click.prevent="prev" class="flecha fisq">
        <img class="arrow" src="../assets/der.png" alt />
      </span>

      <book class="book" :data="pages" :turnPageByHand="false" ref="book">
        <!-- Aqui tienes las flechas ???? -->

        <template slot-scope="prop">
          <!-- imagen del cuento en grande -->
          <img v-if="prop.page.cover" :src="prop.page.urlcover" />

          <Contenido
            :texto="prop.page.title"
            :pictogramas="prop.page.pictogramas"
            :audio="prop.page.urlaudio"
            :funcion="next"
            :principal="prop.page.principal"
            :home="prop.page.home"
            :sonido="prop.page.sonido"
            :preguntas="prop.page.preguntas"
            :elije="prop.page.elije"
            :datos="prop.page.datos"
            :imagenfinal="prop.page.imagenfinal"
            :creditos="prop.page.creditos"
            :cerrar="prop.page.cerrar"
            :botonesdescarga="prop.page.botonesdescarga"
            :botonconfirmar="prop.page.botonconfirmar"
            :elejido="prop.page.elejido"
            :detenerAnimacion="detenerAnimacion"
          />
        </template>
      </book>
    </div>
  </div>
</template>

<script>
import Contenido from "./Contenido";
import $ from "jquery";
import book from "vue-book-component";
import axios from "axios";

export default {
  name: "Cuento",
  components: { book, Contenido },
  data() {
    return {
      init: false,
      end: false,
      page: 1,
      detenerAnimacion: false,
      pages: [
        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Portada.png"),
          title: "",
        },
        {
          cover: false,
          have_title: false,
          button: false,
          title: "",
          principal: true,
          opciones: false,
          datos: true,
          creditos: true,
          cerrar: true,
          elejido: false,
          sonido: true,
          urlaudio: new Audio(require("../assets/sonido/BIENVENIDA.mp3")),  
        },
        {
          cover: true,
          have_title: false,
          button: true,
          urlcover: require("../assets/Pag1.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          home: true,
          sonido: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio1.mp3")),

          pictogramas: [
            { url: require("../assets/1 dia.jpg"), name: "UN DÍA" },
            { url: require("../assets/2 una.jpg"), name: "UNA " },
            { url: require("../assets/3 lora.jpg"), name: "LINDA LORA" },
            { url: require("../assets/4 nacio.jpg"), name: "NACIÓ" },
            { url: require("../assets/5 huevo.jpg"), name: "DE UN HUEVO" },
          ],
        },
        {
          cover: true,
          have_title: false,
          button: true,
          urlcover: require("../assets/Pag1_2.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          home: true,
          sonido: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio2.mp3")),

          pictogramas: [
            { url: require("../assets/6 padres.jpg"), name: "SUS PADRES" },
            { url: require("../assets/7 llamar.jpg"), name: "LA LLAMARON" },
            { url: require("../assets/8 loly.jpg"), name: "LOLY" },
          ],
        },

        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag2_2.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio3.mp3")),
          principal: false,
          sonido: true,
          home: true,

          pictogramas: [
            { url: require("../assets/8 loly.jpg"), name: "LOLY" },
            { url: require("../assets/9 ir.jpg"), name: "IBA" },
            { url: require("../assets/10 parque.jpg"), name: "AL PARQUE" },
            { url: require("../assets/11 mama.jpg"), name: "CON SU MAMÁ" },
          ],
        },
        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag2.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio4.mp3")),
          principal: false,
          sonido: true,
          home: true,

          pictogramas: [
            { url: require("../assets/8 loly.jpg"), name: "LOLY" },
            { url: require("../assets/12 parque.jpg"), name: "JUGABA",delay:-200 },
            { url: require("../assets/13 sola.jpg"), name: "SOLA O" },
            { url: require("../assets/14 amigos.jpg"), name: "CON SUS AMIGOS" },
          ],
        },

        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag3.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio5.mp3")),
          sonido: true,
          home: true,

          pictogramas: [
            { url: require("../assets/8 loly.jpg"), name: "A LOLY" },
            { url: require("../assets/15 gustaba.jpg"), name: "LE GUSTABA" },
            { url: require("../assets/16 estudiar.jpg"), name: "ESTUDIAR" },
            { url: require("../assets/18 mucho.jpg"), name: "MUCHO" },
            { url: require("../assets/17 juntos.jpg"), name: "JUNTO A" },
            { url: require("../assets/19 companieros.jpg"), name: "SUS COMPAÑEROS" },
            { url: require("../assets/20 clase.jpg"), name: "DE CLASE" },
          ],
        },

        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag4.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio7.mp3")),
          sonido: true,
          home: true,

          pictogramas: [
            //{ url: require("../assets/a.jpg"), name: "A" },
            //{ url: require("../assets/amenudo.jpg"), name: "MENUDO" },
            { url: require("../assets/8 loly.jpg"), name: "LOLY" },
            { url: require("../assets/21 soniar.jpg"), name: "SOÑABA CON" },
            { url: require("../assets/22 ayuda.jpg"), name: "AYUDAR A" },
            { url: require("../assets/23 otros.jpg"), name: "OTROS" },
            { url: require("../assets/24 ninios.jpg"), name: "NIÑOS" },
            { url: require("../assets/25 aprender.jpg"), name: "A APRENDER" },
          ],
        },

        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag5.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio9.mp3")),
          sonido: true,
          home: true,
          pictogramas: [
            { url: require("../assets/26 grande.jpg"), name: "DE GRANDE," },
            { url: require("../assets/8 loly.jpg"), name: "LOLY" },
            { url: require("../assets/27 trabajo.jpg"), name: "TRABAJÓ" },
            { url: require("../assets/28 duro.jpg"), name: "MUY DURO" },
            { url: require("../assets/29 cumplir.jpg"), name: "PARA CUMPLIR" },
            { url: require("../assets/21 soniar.jpg"), name: "SUS SUEÑOS" },
          ],
        },

        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag6.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          home: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio10.mp3")),
          sonido: true,

          pictogramas: [
            { url: require("../assets/30 armo.jpg"), name: "Y CREÓ AL" },
            { url: require("../assets/31 robot loly.jpg"), name: "ROBOT LOLY," },
            { url: require("../assets/32 quien.jpg"), name: "QUIEN", delay:450 },
            { url: require("../assets/33 te.jpg"), name: "TE" },
            { url: require("../assets/22 ayuda.jpg"), name: "AYUDARÁ" },
            { url: require("../assets/25 aprender.jpg"), name: "A APRENDER" },
            { url: require("../assets/12 parque.jpg"), name: "JUGANDO" },
          ],
        },
        {
          cover: true,
          have_title: false,
          button: false,
          urlcover: require("../assets/Pag7.png"),
          title: "",
        },
        {
          cover: false,
          have_title: true,
          button: true,
          principal: false,
          sonido: true,
          home: true,
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio11.mp3")),

          pictogramas: [
            { url: require("../assets/17 juntos.jpg"), name: "JUNTO A" },
            { url: require("../assets/31 robot loly.jpg"), name: "ROBOT LOLY" },
            { url: require("../assets/34 alcanzaras.jpg"), name: "ALCANZARÁS" },
            { url: require("../assets/21 soniar.jpg"), name: "TUS SUEÑOS" },
            { url: require("../assets/35 igual.jpg"), name: "AL IGUAL" },
            { url: require("../assets/8 loly.jpg"), name: "QUE ELLA" },
          ],
        },
        {
          cover: false,
          have_title: false,
          button: false,
          urlcover: "",
          title: "",
          urlaudio: new Audio(require("../assets/sonido/audio12.mp3")),
          sonido: true,
          home: false,
          creditos: false,
          cerrar: false,
          imagenfinal: true,

          pictogramas: [
            { url: require("../assets/36 fin.jpg"), name: "FIN" },
          ],
        },
        {
          cover: false,
          have_title: true,
          button: false,
          urlaudio: new Audio(require("../assets/sonido/pregunta.mp3")),
          sonido: true,
          urlcover: "",
          title: "",
          principal: true, //div principal de preguntas
          preguntas: true, // seccion preguntas
          home: true, //boton home
          elije: true,
          datos: false, //datos nombre y edad
          cerrar: true,
          creditos: true,
          botonesdescarga: true,
          botonconfirmar: true,
          elejido: true,
        },
      ],
    };
  },
  methods: {
  
    async enviarEvento(Id) {
      //var fechaHora = new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString();
      //var robotS = loc var robotS = localStorage.getItem("escuela") + "-" + localStorage.getItem("salam") + "-" + "Conociendo a Loly";
    //   const config = {
    //     headers: { 'Authorization': localStorage.getItem("token") }
    //   };
    //   const bodyE = {
    //     urlRobot: 'http://localhost:8910',
    //     estudiante: localalStorage.getItem("escuela") + "-" + localStorage.getItem("salam") + "-" + "Conociendo a Loly" + "_" + fechaHora;
    //  Storage.getItem("nombreP"),
    //     robot: robotS
    //   };
    //   await axios.post(localStorage.getItem("urlm") + '/lolyapi/v1/send/' + Id, bodyE, config)
    //     .then(response => {
    //       localStorage.setItem("comprobar", response.status);
    //       console.log(response);
    //     });
    },
    detenerAudios() {
      this.pages.forEach(page => {
        if (page.urlaudio) {
          page.urlaudio.pause();
          page.urlaudio.currentTime = 0;
        }
      });
    },
    detenerAnimaciones() {
      this.detenerAudios();
      this.detenerAnimacion = true;
      setTimeout(() => {
          this.detenerAnimacion = false;
        }, 1000);
    },
    next() {
      if (!this.$refs.book.animating) {
        this.init = true;
        this.end = true;
        if (this.$refs.book.curPage === this.pages.length / 2 - 1) {
          this.end = false;
          this.init = false;
        
        }
        this.detenerAnimaciones();
        this.enviarEvento(28);
        this.$refs.book.next();
        this.$refs.book.resetAnimateClass();
      }      
    },

    prev() {
      if (!this.$refs.book.animating) {
        if (this.$refs.book.curPage === 2) {
          this.init = false;
        }

        if (this.$refs.book.curPage === this.pages.length / 2) {
          this.end = true;
        }
        this.detenerAnimaciones();
        this.enviarEvento(28);
        this.$refs.book.prev();
        this.$refs.book.resetAnimateClass();
      }
     
    },
  },
  mounted: function () {},
};
</script>




<style scoped>
.home {
  box-sizing: border-box;
  width: 100%;
  height: 99vh;
  transition: 0.5s;
  position: relative;
}

.book {
  /* position: relative;*/
  position: relative;
  margin: 0 auto;
  width: 95%;
  height: 93vh;
}

.bookMain {
  border: none !important;
  box-shadow: 0 0 20px #888;
}
.book img {
  width: 97%;
  height: 100%;
}

.flecha {
  font-size: 36pt;
  cursor: pointer;
  z-index: 10;
  position: absolute;
}

.fdere {
  right: 10px;
}

.fisq {
  left: 10px;
}

.fdere,
.fisq {
  top: 45%;
}

.arrow {
  width: 125px;
  height: auto;
}

.alert {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
}

.alert h1 {
  box-sizing: border-box;
}

.pasta {
  margin: 0 auto;
  width: 92% !important;
  height: 98vh;
  background-image: url(../assets/Pasta.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 0.8%;
}

@media only screen and (orientation: portrait) {
  .alert {
    display: block;
  }
}
@media only screen and (orientation: landscape) {
  .alert {
    display: none;
  }
}

@media only screen and (max-width: 1024px) {
  .arrow {
    width: 90px;
    height: auto;
  }
  .fisq {
    left: -16px;
  }
  .fdere {
    right: -8px;
  }
}

@media only screen and (max-width: 825px) {
  .arrow {
    width: 90px;
    height: auto;
  }
  .fisq {
    left: -11px;
  }
  .fdere {
    right: -6px;
  }
}

@media only screen and (max-width: 375) {
  .arrow {
    width: 36px;
  }

  .fisq {
    left: 3px;
  }
  .fdere {
    right: 3px;
  }
}
</style>